import React from "react";
import cx from "classnames";

const infoBannerStyles = {
    egg_donor: "start-banner-green",
    surrogate: "start-banner-blue",
    parent: "start-banner-grey",
    milk_donor: "start-banner-pink"
};

function ProfileBannerComponent({ title, textContent, surveyType, navigateToSurvey }) {
    const onBannerClick = (event) => {
        const regex = new RegExp("[#]", "g");
        if (
            event.target.id !== "calendly-link" &&
            event.target.id !== "coordinator-link" &&
            !regex.test(event.target.href) &&
            event.target.className !== "embed-popup-button"
        ) {
            navigateToSurvey && navigateToSurvey();
        }
    };

    return (
        <div className={cx("start-banner", infoBannerStyles[surveyType])} onClick={onBannerClick}>
            <div className="bg" />
            <h1>{title}</h1>
            {textContent}
        </div>
    );
}

export default ProfileBannerComponent;
